export interface Employee {
  id: string;
  fullName: string;
  pencomPin: string;
  dateOfAppointment: string;
  consolidatedBHT: number;
  rsaPin: string;
  migratedFromECRS: boolean;
  ecrsEmployeeMigrationDate: string;
  // In API response, `pfa` is an object with at least a `name` field.
  // We keep it flexible here to match the backend shape.
  pfa: {
    name?: string;
    [key: string]: unknown;
  } | string;
  status: EmployeeStatus;
  changePendingAdminApproval: boolean;
  lastModifiedByUserId: string;
  designation?: string;
  totalSalary?: string;
}

export enum EmployeeStatus {
  ACTIVE = "active",
  REMOVED_PENDING_APPROVAL = "removed_pending_approval",
  REMOVED_APPROVED = "removed_approved",
  PENDING_APPROVAL = 'pending_approval',
  QUERIED = 'queried'
}
